import axiosClient from "../axiosClient";

export const createCheckoutSession = async ({ uid, plan }) => {
  const response = await axiosClient.post("/stripe/create-checkout-session", {
    uid,
    plan,
  });

  return response.data;
};

export const cancelSubscription = async ({ uid }) => {
  const response = await axiosClient.post("/stripe/cancel-subscription", {
    uid,
  });

  return response.data;
};
